import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import AppState from "../interfaces/AppState";

const initialState: AppState = {
    isLoading: true,
    hasBootstrapLoaded: false,
    messages: [],
};

export default function appReducer(state: AppState = initialState, action: Action): AppState {
    switch (action.type) {
        case ActionTypeEnum.APP_IS_LOADING_SET:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case ActionTypeEnum.APP_HAS_BOOTSTRAP_LOADED_SET:
            return {
                ...state,
                hasBootstrapLoaded: action.hasLoaded,
            };
        case ActionTypeEnum.APP_MESSAGES_SET:
            return {
                ...state,
                messages: action.messages,
            };
        case ActionTypeEnum.APP_MESSAGES_ADD:
            return {
                ...state,
                messages: state.messages.concat(action.message),
            };
        default:
            return state;
    }
}
